import { createContext } from 'react';
import type { StationOption } from '../types/stationAssets';

export type SelectedStationContextValue = {
  organizationId?: string;
  selectedStationId: string;
  selectedStation?: StationOption;
  availableStations: StationOption[];
  stationLocked: boolean;
  setSelectedStationId: (stationId: string) => void;
  clearSelectedStation: () => void;
};

export const SelectedStationContext = createContext<SelectedStationContextValue | undefined>(
  undefined
);
